<template>
  <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
    <form @submit.prevent="submit">
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
        <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" />
        <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Last name" />
        <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
        <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" type="password" autocomplete="new-password" label="Password" />
        <select-input v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full lg:w-1/2" label="Type">
          <option v-if="loggedUserType === 'ADMIN'" value="ADMIN">ADMIN</option>
          <option v-if="loggedUserType === 'ADMIN'" value="PARTNER">PARTNER</option>
          <option v-if="loggedUserType === 'ADMIN' || loggedUserType === 'PARTNER'" value="TECHNICIAN">TECHNICIAN</option>
          <option v-if="loggedUserType === 'ADMIN' || loggedUserType === 'TECHNICIAN' || loggedUserType === 'PARTNER'" value="VIEWER">VIEWER</option>
        </select-input>
        <select-input v-model="form.project_id" :error="form.errors.project_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Project">
          <option :value="null">Select a project</option>
          <option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }}</option>
        </select-input>

        <file-input v-model="form.photo" :error="form.errors.photo" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />

        <select-input v-if="loggedUserType === 'ADMIN'" v-model="form.organization_id" :disabled="loggedUserType!=='ADMIN'" :error="form.errors.organization_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Organization">
          <option :value="null">Select an organization</option>
          <option v-for="organization in organizations" :key="organization.id" :value="organization.id">{{ organization.name }}</option>
        </select-input>
      </div>
      <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
        <slot name="actions"></slot>
      </div>
    </form>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput.vue'
import SelectInput from '@/Shared/SelectInput.vue'
import FileInput from '@/Shared/FileInput.vue'

export default {
  components: { FileInput, SelectInput, TextInput },
  props: {
    form: Object,
    projects: Array,
    organizations: Array,
    showTypeField: {
      type: Boolean,
      default: false,
    },
    showOrganizationField: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    loggedUserType: {
      type: String,
      default: 'TECHNICIAN'
    },
    isTechnician: {
      type: Boolean,
      default: false
    },
    isPartner: {
      type: Boolean,
      default: false
    },
    canSelectProject: {
      type: Boolean,
      default: true,
    },
    submit: {
      type: Function,
      required: true,
    },
  }
}
</script>
